// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'members',
    path: '/dashboard/members',
    icon: icon('ic_user'),
  },
  {
    title: 'attendance',
    path: '/dashboard/attendance',
    icon: icon('ic_prediction'),
  }, 
  {
    title: 'Settings',
    path: '/users/settings',
    icon: icon('ic_settings'),
  }, 
];

export default navConfig;
